import cx from "classnames";
import { useState } from "react";

import { Icon } from "atoms/icon/Icon";
import ChevronDownSmall from "atoms/icon/icons/chevron_down_small.svg";
import ChevronUpSmall from "atoms/icon/icons/chevron_up_small.svg";
import {
  RedeemedReward,
  RedeemedRewardProps,
} from "molecules/containers/reward/redeemed-reward/RedeemedReward";

export interface RedeemedRewardListProps {
  rewards: RedeemedRewardProps[];
  titleClassName?: string;
  isReferralProgramEnabled?: boolean;
}

export const RedeemedRewardList = ({
  rewards,
  titleClassName = "pb-6 text-center font-sans text-sub2 text-secondary",
  isReferralProgramEnabled = false,
}: RedeemedRewardListProps) => {
  const [expanded, setExpanded] = useState(false);

  const handleClick = () => {
    setExpanded((expanded) => !expanded);
  };

  const visibleRewards = expanded ? rewards : rewards.slice(0, 3);

  if (!rewards.length) return null;

  return (
    <div>
      <div className={titleClassName}>REWARD HISTORY</div>
      <div
        className={cx(
          !isReferralProgramEnabled &&
            "divide-background-two rounded-lg shadow-subtle",
          "divide-background-one divide-y divide-solid overflow-clip border-y"
        )}
      >
        {visibleRewards.map((reward) => (
          <RedeemedReward key={reward.id} {...reward} />
        ))}
        <div
          className={cx(
            "flex cursor-pointer justify-between bg-white px-4 py-3",
            rewards.length < 4 && "hidden"
          )}
          onClick={handleClick}
        >
          <div className="text-bold1 text-brand-color">
            {expanded ? "Hide rewards" : "See more rewards"}
          </div>
          <Icon
            color="brandColor"
            size="xsmall"
            svg={expanded ? ChevronUpSmall : ChevronDownSmall}
          />
        </div>
      </div>
    </div>
  );
};
